import React from 'react'

const Manual_forma_pago_manual_clau = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          Configurar forma de pago Manual en Clau.io
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Aprende a configurar métodos de pago manuales personalizados dentro del sistema Ecommerce de Clau.io.
        </p>
        <iframe
          src="https://scribehow.com/embed/Configurar_forma_de_pago_Manual_en_Clau_io__jh8bFHM-Rza495ig2kYR9A?as=scrollable"
          className="scribe-iframe-general-110"
          width="100%"
          height="4700"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_forma_pago_manual_clau
